import axios from "axios";
import { LogHelper } from "@/common/LogHelper";
import { Message } from "element-ui";

export class RfidService {
  private static baseUrl = "http://api-hbd.yto.net.cn:8086"
  private static token: string;

  public static initialize(baseUrl: string, token: string) {
    RfidService.baseUrl = baseUrl?.endsWith("/") ? baseUrl.substr(0, baseUrl.length - 1) : baseUrl;
    RfidService.token = token;
  }

  public static checkRepairBagsign(repairBagsign: string) {
    const data = {
      repairBagsign
    };
    return RfidService.post("/hbd/repaireFactoryController/checkRepairBagsign", data, { isShowErrorMsg: false })
      .then(() => ({
        success: true,
        message: '',
      }))
      .catch((err) => ({ success: false, message: err?.message || "接口失败"}))
  }

  public static querySupplier() {
    return RfidService.get("/hbd/supplier/querySupplierNew")
      .then(res => res ? res.map((item) => ({ value: item.supplierCode, label: item.supplierName })) : []);
  }

  public static queryRepairFactory() {
    return RfidService.get("/hbd/repairFactory/queryRepairFactory")
      .then(res => res ? res.map((item) => ({ value: item.siteCode, label: item.siteName })) : []);
  }

  static post(action: string, data?: any, options?) {
    options = {
      ...options,
      method: 'post',
    }
    return RfidService.request(action, data, options)
  }

  static get(action: string, data?: any, options?) {
    options = {
      ...options,
      method: 'get',
    }
    return RfidService.request(action, data, options)
  }

  static request(action: string, data?: any, options?) {
    const url = RfidService.baseUrl + action;
    LogHelper.WriteLog(`请求url：${url}, 请求参数: ${JSON.stringify(data)}`)
    const method = options?.method || 'post';
    const config = {
      headers: {
        ...(options?.useToken ? { Authorization: RfidService.token } : {}),
      },
      timeout: 60 * 1000,
      url,
      method,
      [method === 'post' ? 'data' : 'params']: data,
    };
    return axios.request(config)
      .then((res) => {
        const { data } = res;
        if (data) {
          LogHelper.WriteLog(`响应内容：${JSON.stringify(data)}`);
        }
        if (data.status === 0) {
          return data.data;
        } else {
          const { message } = data;
          if (options?.isShowErrorMsg !== false) {
            Message.error(message);
          }
          return Promise.reject({ message })
        }
      })
      .catch((err) => {
        LogHelper.WriteLog(err.message);
        return Promise.reject(err);
      })
  }
}
